/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { getAppConfig } from '@web/src/lib/env.dynamic.client'

/** Values aligned with `@repo/shared-server` `DOPPLER_ENVIRONMENT` schema. */
export type DopplerEnvironment = 'development' | 'production' | 'staging'

export function getDopplerEnvironment(): DopplerEnvironment | undefined {
  const raw = getAppConfig().DOPPLER_ENVIRONMENT
  if (raw === 'development' || raw === 'production' || raw === 'staging') {
    return raw
  }
  return undefined
}

export function isProductionEnvironment(): boolean {
  return getAppConfig().DOPPLER_ENVIRONMENT === 'production'
}

export function isDevelopmentEnvironment(): boolean {
  return getAppConfig().DOPPLER_ENVIRONMENT === 'development'
}

export function isStagingEnvironment(): boolean {
  return getAppConfig().DOPPLER_ENVIRONMENT === 'staging'
}

/** True for development, staging, unknown, or unset — anything other than production. */
export function isNonProductionEnvironment(): boolean {
  return getAppConfig().DOPPLER_ENVIRONMENT !== 'production'
}
